import { MediaQueries } from '@hhgtech/hhg-components'

export const CommonStyle = `
  .sticky-bottom-ad {
    background-color: transparent;
    /* Mobile bottom bar height */
    margin-bottom: var(--mobile-bottom-height);
    @supports (margin-bottom: env(safe-area-inset-bottom)) {
      margin-bottom: calc(
        env(safe-area-inset-bottom) + var(--mobile-bottom-height)
      );
    }
    ${MediaQueries.mbUp} {
      margin-bottom: 0;
    }
  }
`
